<template>
  <div id="app" ref="scrollToMe">
    <TopBar v-if="isUserLoggedIn" />
    <div class="columns app-columns">
      <SideBar
        v-if="isUserLoggedIn"
        class="column is-one-quarter has-text-left sidebar-column"
      />
      <MainBar class="column main-column" />
    </div>
  </div>
</template>

<script>
/**
 * This file is the main app file injected in the html file containing a side panel with different tabs and a top bar
 * with logo and logout.
 */
import TopBar from "@/components/bars/Topbar";
import SideBar from "@/components/bars/Sidebar";
import MainBar from "@/components/bars/Mainbar";
import Parse from "parse/dist/parse.min";

export default {
	name: "App",
	components: { MainBar, TopBar, SideBar },
	mounted() {
		// log <-- error <-- warn <-- info <-- debug
		// wenig inklusive - sehr inklusiv
		//this.$log.apply({ level: 'error' })
	},
	computed: {
		isUserLoggedIn() {
			if (Parse.User.current()) return true;
			return false;
		},
	},
};
</script>

<style scoped>
#app {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.app-columns {
	flex: 1 0 auto;
}

.main-column {
	min-width: 0;
}

@media (max-width: 768px) {
	.sidebar-column {
		display: none;
	}
}

/* Bulma columns bleed 0.75rem past the viewport on both sides, which
   shifts the 25% column edge off the top bar's 25% brand width. Pin
   the row to the viewport so the two dividers align. */
.app-columns {
	margin-left: 0;
	margin-right: 0;
	margin-top: 0;
}

/* Padding instead of margin so the divider reaches the top bar. */
.sidebar-column {
	border-right: 2px solid rgb(240, 240, 240);
	/* No horizontal padding: the section hairlines span the full width
	up to the divider; the inset lives inside the menu. */
	padding: 0.5rem 0 0.75rem;
}
</style>


<style lang="scss">
#app {
	text-align: center;
	color: #2c3e50;
	margin-top: 0;
}

.panel-heading {
	background-color: rgba(0, 0, 0, 0.8) !important;
	color: white !important;
	text-align: left;
}

.is-pulled-right {
	color: white;
}

div {
	user-select: none;
}

p {
	user-select: text;
}
</style>
